// Returns the clients timezone or undefined if the operation isn't support by the
// user's client. Supported in all browsers except IE
export default function useClientTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch (e) {
    return undefined
  }
}
